// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__XN83C","info":"UpdateTermsInfo_info__2G8wP"};